import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NewNavbar from "./NewNavbar";
import NewFooter from "./NewFooter";
import NewCopyright from "./NewCopyright";

const MainLayout = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="flex flex-col min-h-screen">
      <NewNavbar />
      <div className="flex-1">
        <Outlet />
      </div>
      <NewFooter />
      <NewCopyright />
    </div>
  );
};

export default MainLayout; 